import { render, staticRenderFns } from "./index.vue?vue&type=template&id=02a9b4c1&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=02a9b4c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a9b4c1",
  null
  
)

export default component.exports